import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';

 
import gql from 'graphql-tag';
import { hex_md5 } from '../../util/Md5';
import axios from 'axios';

import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import CatalogoOrganizacion from '../../catalogos/catalogoOrganizacion';
import CatalogoPersona from '../../catalogos/catalogoPersona';
import {
    validaSoloNumero, validaMonto, formatoMonto,
    seleccionarCampo, validaNumeroTelefono, validaEmail
} from '../../util/varios';

import moment from 'moment';


export const ActualizarUsuario = (props) => {


    const array = JSON.parse(localStorage.getItem('permisos'))


    /*  variables de estados */

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const btnEnviar = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar1, setMostrar1] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [contar, setContar] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [dato, setDato] = useState([3]);
    const [dato2, setDato2] = useState('');
    const [password, setPassword] = useState('');
    const [activate, setActivate] = useState(false);
    const [usuario, setUsuario] = useState();
    const [organizacion, setOrganizacion] = useState({ idorganizacion: '', razonsocial: '' });
    const [persona, setPersona] = useState({ cedula: '', nombres: '', apellidos: '', direccion: '', correoe: '', tlf1: '', tlf2: '', fnacimiento: '', nacionalidad: '', sexo: '' });
    const [mostrarClave, setMostrarClave] = useState(false);
    const [mostrarClave1, setMostrarClave1] = useState(false);
    const [correo, setCorreo] = useState('');
    const [modulos, setModulos] = useState({
        accaprosolicompra: '0',
        acclisgencompraalmacen: '0',
        acclissolicompraalmacen: '0',
    });
    const [permisos, setPermisos] = useState({
        accproveedor: '0000',
        accunimedi: '0000',
        acctipoproducto: '0000',
        accproducto: '0000',
        accrequisicion: '0000',
        accsolicompra:'0000',
        accusuariocompra: '0000',
    });

    const [url, setUrl] = useState('');

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habilitadoNU, setHabilitadoNU] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [operacionPer, setOperacionPer] = useState(0);
    const [tecla, setTecla] = useState();
    const [tabIndex, setTabIndex] = useState(0);
    const [tabIndex1, setTabIndex1] = useState(0);
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [desde, setDesde] = useState(0);
    const txtIdUsuario = useRef();
    const txtLogin = useRef();
    const txtPassword = useRef();
    const txtConfirmPassword = useRef();
    const txtIdOrg = useRef();
    const txtNomOrg = useRef();
    const txtCedula = useRef();
    const txtNombreUsuario = useRef();
    const txtApellidoUsuario = useRef();
    const txtDireccionUsuario = useRef();
    const txtEmailUsuario = useRef();
    const txtTlfUsuario = useRef();
    const txtCelUsuario = useRef();
    const txtFechaNac = useRef();
    const cmbNacionalidad = useRef();
    const cmbSexo = useRef();
    const chkLiquidador = useRef();
    const chkPoseeImpresora = useRef();
    const radioPuertoU = useRef();
    const radioPuertoP = useRef();
    const radioPuertoS = useRef();

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        /*var nanio = []
        var aini = parseInt(obj[0].anioactu) - 7;
        var afin = parseInt(obj[0].anioactu);
        for (let i = 1; i <= afin - aini; i++) {
            nanio.push({ anio: aini + i });

        }
        setAnio(nanio);*/
        if (props.operacion) {
            setOperacion(props.operacion);
        }

        if (op.reportes != null) {

            setUrl(op.reportes.trim());

        } else {
            setUrl('');
        }

    }, [props.operacion]);





    const procesarRegistro = (body) => {

        let endpoint = `${op.conexion}/api/comun/actualizarusuario/${operacion}`;
        console.log(body)
        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                let per = JSON.parse(localStorage.getItem('idusuario'));
                if (per === txtIdUsuario.current.value) {


                    localStorage.setItem('accaprosolicompra', JSON.stringify(modulos.accaprosolicompra))
                    localStorage.setItem('acclisgencompraalmacen', JSON.stringify(modulos.acclisgencompraalmacen))
                    localStorage.setItem('acclissolicompraalmacen', JSON.stringify(modulos.acclissolicompraalmacen))
                    localStorage.setItem('accproveedor', JSON.stringify(permisos.accproveedor))
                    localStorage.setItem('accunimedi', JSON.stringify(permisos.accunimedi))
                    localStorage.setItem('acctipoproducto', JSON.stringify(permisos.acctipoproducto))
                    localStorage.setItem('accproducto', JSON.stringify(permisos.accproducto))
                    
                    localStorage.setItem('accrequisicion', JSON.stringify(permisos.accrequisicion))
                    localStorage.setItem('accsolicompra', JSON.stringify(permisos.accsolicompra))

                    localStorage.setItem('accusuariocompra', JSON.stringify(permisos.accusuariocompra))

                }




                if (operacion === 1) {
                    setMensaje({ mostrar: true, titulo: "Exito.", texto: "El usuario " + response.data.iduser + " ha sido registrado de manera satisfactoria.", icono: "exito" });


                } else if (operacion === 2) {

                    setMensaje({ mostrar: true, titulo: "Exito.", texto: "El usuario " + response.data.iduser + " ha sido modificado de manera satisfactoria.", icono: "exito" });

                } else if (operacion === 3) {

                    setMensaje({ mostrar: true, titulo: "Exito.", texto: "El usuario " + response.data.iduser + " ha sido eliminado de manera satisfactoria.", icono: "exito" });


                }

                setActivate(false);


            }

        }).catch(function (error) {

            setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });

        })

    }



    const datosOrga = (idorganizacion) => {

        let campos = '*';
        let nomtab = 'organizacion';
        let nomid = 'idorganizacion';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idorganizacion}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                setHabilitadoNU(true);

                if (response.data !== '') {
                    txtNomOrg.current.value = response.data.nombre;
                    txtCedula.current.focus();
                    setContar(contar + 1);

                } else {
                    txtNomOrg.current.value = '';
                    txtIdOrg.current.value = '';
                    setTitulo("Error");
                    setMsg("La Organizacion no existe.");
                    setMostrar(true);
                    setContar(contar + 1);
                }
            }

            setActivate(false);

        }).catch(function (error) {

            setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });

        })

    }



    const datosRes = (cedula) => {

        let campos = '*';
        let nomtab = 'persona';
        let nomid = 'cedula';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                if (props.ingresa === 0) {
                    txtNombreUsuario.current.value = '';
                    txtApellidoUsuario.current.value = '';
                    txtDireccionUsuario.current.value = '';
                    txtEmailUsuario.current.value = '';
                    txtTlfUsuario.current.value = '';
                    txtCelUsuario.current.value = '';
                    txtFechaNac.current.value = '';
                    cmbNacionalidad.current.value = 'V';
                    cmbSexo.current.value = 'M';
                }

                setHabilitadoNU(true);

                if (response.data !== '') {
                    setHabilitadoNU(false);
                    setOperacionPer(0);
                    txtNombreUsuario.current.value = response.data.nombres;
                    txtApellidoUsuario.current.value = response.data.apellidos;
                    txtDireccionUsuario.current.value = response.data.direccion;
                    txtEmailUsuario.current.value = response.data.correoe;
                    txtTlfUsuario.current.value = response.data.tlf1;
                    txtCelUsuario.current.value = response.data.tlf2;
                    txtFechaNac.current.value = moment.utc(response.data.fnacimiento).format('YYYY-MM-DD');
                    cmbNacionalidad.current.value = response.data.nacionalidad;
                    cmbSexo.current.value = response.data.sexo;
                    if (tecla === 13) {
                        setTabIndex(1);
                        setTabIndex1(0)
                        btnAcepta.current.focus();
                    }

                } else {
                    setOperacionPer(1);
                    setHabilitadoNU(true);
                    if (tecla === 13) {
                        setTimeout(() => {
                            txtNombreUsuario.current.focus();
                        }, 100);


                    }
                }
            }

            setActivate(false);

        }).catch(function (error) {

            setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });

        })

    }

    const validarOrg = (event) => {
        validaSoloNumero(event);
        //txtNomOrg.current.value = "";
        //txtNombreRep.current.value = "";
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setContar(0);
                //setActivate(true);
                datosOrga(event.target.value);


            } else {
                txtNomOrg.current.value = '';
                txtIdOrg.current.value = '';
            }
        }
    };

    const handleCloseCatalogo = () => {
        setMostrar2(false);
    };

    const handleAceptaCatalogo = (idOrg, nomOrg, razonOrg) => {
        setMostrar2(false);
        txtIdOrg.current.value = idOrg;
        txtNomOrg.current.value = nomOrg;
    };

    const catalogoOrg = () => {

        setMostrar2(true);


    };

    const handleCloseCatalogoPer = () => {
        setMostrar3(false);
    }

    const handleAceptaCatalogoPer = (cedPer, nomPer, apePer, correoPer, tlf1Per,
        tlf2Per, fnacPer, nacPer, sexoPer, direPer) => {
        setMostrar3(false);
        txtCedula.current.value = cedPer;
        txtNombreUsuario.current.value = nomPer;
        txtApellidoUsuario.current.value = apePer;
        txtDireccionUsuario.current.value = direPer;
        txtEmailUsuario.current.value = correoPer;
        txtTlfUsuario.current.value = tlf1Per;
        txtCelUsuario.current.value = tlf2Per;
        txtFechaNac.current.value = fnacPer;
        cmbNacionalidad.current.value = nacPer;
        cmbSexo.current.value = sexoPer;
        btnAcepta.current.focus();
    }

    const catalogoPer = (e) => {
        e.preventDefault();
        if (operacion < 3) {
            setMostrar3(true);
        }

    };

    /* metodo para restablecer los valores  a su estado inicial */


    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setMostrar1(false);
        setTitulo2('');
        setMsg2('');
        setDato([3]);
        setDato2('');
        setPassword('');
        setActivate(false);
        setCorreo('');
        setDesde(0);
        setModulos({
            accaprosolicompra: '0',
            acclisgencompraalmacen: '0',
            acclissolicompraalmacen: '0',
        });
        setPermisos({
            accvalortipocat: '0000',
            accproveedor: '0000',
            supercat: false,
            accavaluo: '0000',
            accdepreciacioncat: '0000',
            accvalorterrecat: '0000',
            accrepvalconstruc: '0000',
            accusuariocat: '0000',
            accunimedi: '0000',
            acctipoproducto: '0000',
            accproducto: '0000',
            accrequisicion: '0000',
            accsolicompra:'0000',
            accusuariocompra: '0000',
        });

    }




    /* metodo para cerrar la notificacion */





    const cancelar = () => {

        blanquear();

        props.onHideCancela();
    }

    const handleChangeOtro = (event) => {

        setModulos({ ...modulos, [event.target.name]: event.target.value === 'true' ? '1' : '0' });
    };

    const handleChangeChek = (event) => {

        var num;
        num = event.target.checked === true ? '1' : '0';

        if (event.target.name === 'accproveedor') {

            if (event.target.id === 'chkRegContriConsul') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accproveedor.toString().substring(1, 2)
                        + permisos.accproveedor.toString().substring(2, 3)
                        + permisos.accproveedor.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkRegContriInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accproveedor.toString().substring(0, 1)
                        + num
                        + permisos.accproveedor.toString().substring(2, 3)
                        + permisos.accproveedor.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkRegContriEdit') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accproveedor.toString().substring(0, 1)
                        + permisos.accproveedor.toString().substring(1, 2)
                        + num
                        + permisos.accproveedor.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkRegContriElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accproveedor.toString().substring(0, 1)
                        + permisos.accproveedor.toString().substring(1, 2)
                        + permisos.accproveedor.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkRegContriTodo') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });

            }


        } else if (event.target.name === 'accunimedi') {

            if (event.target.id === 'chkActiviEconoConsul') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accunimedi.toString().substring(1, 2)
                        + permisos.accunimedi.toString().substring(2, 3)
                        + permisos.accunimedi.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accunimedi.toString().substring(0, 1)
                        + num
                        + permisos.accunimedi.toString().substring(2, 3)
                        + permisos.accunimedi.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoEdit') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accunimedi.toString().substring(0, 1)
                        + permisos.accunimedi.toString().substring(1, 2)
                        + num
                        + permisos.accunimedi.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accunimedi.toString().substring(0, 1)
                        + permisos.accunimedi.toString().substring(1, 2)
                        + permisos.accunimedi.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkActiviEconoTodo') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });

            }


        } else if (event.target.name === 'acctipoproducto') {

            if (event.target.id === 'chkActiviEconoConsul2') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.acctipoproducto.toString().substring(1, 2)
                        + permisos.acctipoproducto.toString().substring(2, 3)
                        + permisos.acctipoproducto.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoInc2') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.acctipoproducto.toString().substring(0, 1)
                        + num
                        + permisos.acctipoproducto.toString().substring(2, 3)
                        + permisos.acctipoproducto.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoEdit2') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.acctipoproducto.toString().substring(0, 1)
                        + permisos.acctipoproducto.toString().substring(1, 2)
                        + num
                        + permisos.acctipoproducto.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoElim2') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.acctipoproducto.toString().substring(0, 1)
                        + permisos.acctipoproducto.toString().substring(1, 2)
                        + permisos.acctipoproducto.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkActiviEconoTodo2') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });

            }


        } else if (event.target.name === 'accproducto') {

            if (event.target.id === 'chkActiviEconoConsul3') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accproducto.toString().substring(1, 2)
                        + permisos.accproducto.toString().substring(2, 3)
                        + permisos.accproducto.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoInc3') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accproducto.toString().substring(0, 1)
                        + num
                        + permisos.accproducto.toString().substring(2, 3)
                        + permisos.accproducto.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoEdit3') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accproducto.toString().substring(0, 1)
                        + permisos.accproducto.toString().substring(1, 2)
                        + num
                        + permisos.accproducto.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoElim3') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accproducto.toString().substring(0, 1)
                        + permisos.accproducto.toString().substring(1, 2)
                        + permisos.accproducto.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkActiviEconoTodo3') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });

            }


        } else if (event.target.name === 'accrequisicion') {

            if (event.target.id === 'chkActiviEconoConsul4') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accrequisicion.toString().substring(1, 2)
                        + permisos.accrequisicion.toString().substring(2, 3)
                        + permisos.accrequisicion.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoInc4') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accrequisicion.toString().substring(0, 1)
                        + num
                        + permisos.accrequisicion.toString().substring(2, 3)
                        + permisos.accrequisicion.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoEdit4') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accrequisicion.toString().substring(0, 1)
                        + permisos.accrequisicion.toString().substring(1, 2)
                        + num
                        + permisos.accrequisicion.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoElim4') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accrequisicion.toString().substring(0, 1)
                        + permisos.accrequisicion.toString().substring(1, 2)
                        + permisos.accrequisicion.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkActiviEconoTodo4') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });

            }


        } else if (event.target.name === 'accsolicompra') {

            if (event.target.id === 'chkActiviEconoConsul5') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accsolicompra.toString().substring(1, 2)
                        + permisos.accsolicompra.toString().substring(2, 3)
                        + permisos.accsolicompra.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoInc5') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accsolicompra.toString().substring(0, 1)
                        + num
                        + permisos.accsolicompra.toString().substring(2, 3)
                        + permisos.accsolicompra.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoEdit5') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accsolicompra.toString().substring(0, 1)
                        + permisos.accsolicompra.toString().substring(1, 2)
                        + num
                        + permisos.accsolicompra.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoElim5') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accsolicompra.toString().substring(0, 1)
                        + permisos.accsolicompra.toString().substring(1, 2)
                        + permisos.accsolicompra.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkActiviEconoTodo5') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });

            }


        } else if (event.target.name === 'accusuariocompra') {

            if (event.target.id === 'chkUsuarioComeConsul') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accusuariocompra.toString().substring(1, 2)
                        + permisos.accusuariocompra.toString().substring(2, 3)
                        + permisos.accusuariocompra.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkUsuarioComeInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accusuariocompra.toString().substring(0, 1)
                        + num
                        + permisos.accusuariocompra.toString().substring(2, 3)
                        + permisos.accusuariocompra.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkUsuarioComeEdit') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accusuariocompra.toString().substring(0, 1)
                        + permisos.accusuariocompra.toString().substring(1, 2)
                        + num
                        + permisos.accusuariocompra.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkUsuarioComeElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accusuariocompra.toString().substring(0, 1)
                        + permisos.accusuariocompra.toString().substring(1, 2)
                        + permisos.accusuariocompra.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkUsuarioComeTodo') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });
            }


        } 
    }

    const handleInputChange = (event) => {
        if (event.which === 13) {
            var valido;
            if (event.target.id === 'inputCodigo') {
                txtLogin.current.focus();
            } else if (event.target.id === 'inputLogin') {
                txtPassword.current.focus();
            } else if (event.target.id === 'inputPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setTitulo('Información');
                    setMsg('Las Contraseñas no coinciden.');
                    setMostrar(true);
                    txtPassword.current.focus();
                } else {
                    txtConfirmPassword.current.focus();
                }

            } else if (event.target.id === 'inputConfirmPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setTitulo('Información');
                    setMsg('Las Contraseñas no coinciden.');
                    setMostrar(true);
                    txtConfirmPassword.current.focus();
                } else {
                    txtIdOrg.current.focus();
                }

            } else if (event.target.id === 'inputNomUsuario') {
                txtApellidoUsuario.current.focus();
            } else if (event.target.id === 'inputApeUsuario') {
                txtDireccionUsuario.current.focus();
            } else if (event.target.id === 'inputDireUsuario') {
                txtEmailUsuario.current.focus();
            } else if (event.target.id === 'inputEmailUsuario') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlfUsuario.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de Email invalido.');
                        setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtTlfUsuario.current.focus();
                    }
                }

            } else if (event.target.id === 'inputTlfUsuario') {
                valido = validaNumeroTelefono(event.target.value);
                if (valido) {
                    txtCelUsuario.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de número telefonico invalido.');
                        setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtCelUsuario.current.focus();
                    }
                }
            } else if (event.target.id === 'inputCelUsuario') {
                valido = validaNumeroTelefono(event.target.value);
                if (valido) {
                    txtFechaNac.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de número telefonico invalido.');
                        setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtFechaNac.current.focus();
                    }
                }
            } else if (event.target.id === 'inputFechaNac') {
                cmbNacionalidad.current.focus();
            }
        } else if (typeof (event.which) === 'undefined') {
            if (event.target.id === 'inputPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setTitulo('Información');
                    setMsg('Las Contraseñas no coinciden.');
                    setMostrar(true);
                }
            } else if (event.target.id === 'inputConfirmPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setTitulo('Información');
                    setMsg('Las Contraseñas no coinciden.');
                    setMostrar(true);
                }

            } else if (event.target.id === 'inputEmailUsuario') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlfUsuario.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de Email invalido.');
                        //setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtTlfUsuario.current.focus();
                    }
                }

            } else if (event.target.id === 'inputTlfUsuario') {
                valido = validaNumeroTelefono(event.target.value);
                if (valido) {
                    txtCelUsuario.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de número telefonico invalido.');
                        //setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtCelUsuario.current.focus();
                    }
                }
            } else if (event.target.id === 'inputCelUsuario') {
                valido = validaNumeroTelefono(event.target.value);
                if (valido) {
                    txtFechaNac.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de número telefonico invalido.');
                        //setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtFechaNac.current.focus();
                    }
                }
            } else {
                return false;
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    console.log(permisos)
    console.log(modulos)


    const validarPersona = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        //txtNomOrg.current.value = "";
        //txtNombreRep.current.value = "";
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setContar(0);
                setTecla(event.which);
                //setActivate(true);
                datosRes(event.target.value);


            } else {
                txtNombreUsuario.current.value = '';
            }
        }
    };





    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtLogin.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('El Usuario no debe estar vacio');
            sigue = false;
            setTabIndex(0);
            txtLogin.current.focus();
        } else if (txtPassword.current.value.trim() === '' && operacion === 1) {
            setTitulo('Error');
            setMsg('La Contraseña no debe estar vacia');
            sigue = false;
            setTabIndex(0);
            txtPassword.current.focus();
        } else if (txtConfirmPassword.current.value.trim() === '' && operacion === 1) {
            setTitulo('Error');
            setMsg('La Confirmación de la Contraseña no debe estar vacia');
            sigue = false;
            setTabIndex(0);
            txtConfirmPassword.current.focus();
        } else if (txtPassword.current.value.trim() !== txtConfirmPassword.current.value.trim() && operacion === 1) {
            setTitulo('Error');
            setMsg('Las Contraseñas no coinciden');
            sigue = false;
            setTabIndex(0);
            txtConfirmPassword.current.focus();
        } else if (txtIdOrg.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('El Código de la rganización no debe estar vacio');
            sigue = false;
            setTabIndex(0);
            txtIdOrg.current.focus();
        } else if (txtNomOrg.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('El Nombre de la rganización no debe estar vacio');
            sigue = false;
            setTabIndex(0);
            txtNomOrg.current.focus();
        } else if (txtCedula.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('La cedula no debe estar vacia');
            sigue = false;
            txtCedula.current.focus();
        } else if (txtNombreUsuario.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Los nombres no deben estar vacios');
            sigue = false;
            txtNombreUsuario.current.focus();
        } else if (txtApellidoUsuario.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Los Apellidos no deben estar vacio');
            sigue = false;
            txtApellidoUsuario.current.focus();
        } else if (txtDireccionUsuario.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('La direccion del Usuario no debe estar vacia');
            sigue = false;
            txtDireccionUsuario.current.focus();
        } else if (txtFechaNac.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('La fecha de nacimiento no debe estar vacia');
            sigue = false;
            txtFechaNac.current.focus();
        }


        if (sigue) {

            var user = [];
            var datoPer = [];
            user.push({
                idusuario: txtIdUsuario.current.value === '' ? '0' : txtIdUsuario.current.value,
                login: txtLogin.current.value,
                passwd: txtPassword.current.value,
                idorganizacion: txtIdOrg.current.value,
                persona: txtCedula.current.value,
                accaprosolicompra: modulos.accaprosolicompra,
                acclisgencompraalmacen: modulos.acclisgencompraalmacen,
                acclissolicompraalmacen: modulos.acclissolicompraalmacen,
                accproveedor: permisos.accproveedor,
                accunimedi: permisos.accunimedi,
                acctipoproducto: permisos.acctipoproducto,
                accproducto: permisos.accproducto,
                accrequisicion: permisos.accrequisicion,
                accsolicompra: permisos.accsolicompra,
                accusuariocompra: permisos.accusuariocompra,
            })
            datoPer.push({
                apellidos: txtApellidoUsuario.current.value.trim().toUpperCase(),
                cedula: txtCedula.current.value,
                correoe: txtEmailUsuario.current.value,
                direccion: txtDireccionUsuario.current.value.trim().toUpperCase(),
                fnacimiento: txtFechaNac.current.value,
                nacionalidad: cmbNacionalidad.current.value,
                nombres: txtNombreUsuario.current.value.trim().toUpperCase(),
                sexo: cmbSexo.current.value,
                tlf1: txtTlfUsuario.current.value,
                tlf2: txtCelUsuario.current.value
            })
            setUsuario(user);
            setPersona(datoPer);
            //setOperaPer(operacionPer);
            //props.onHideAcepta(operacionPer, usu, repre, actixcome);
            //setMostrar7(true);
            setActivate(true);
            setContar2(0);
            let body = {
                operacionper: operacionPer,
                usu: JSON.stringify(user),
                perso: JSON.stringify(datoPer)
            };
            procesarRegistro(body);
        } else {
            setMostrar(true);
        }

    };

    const mostrarPassword = () => setMostrarClave(!mostrarClave);
    const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        props.render()
        blanquear()


    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                setDeshabilitado(props.deshabilitado);
                setTabIndex(0);
                setTabIndex1(0);
                console.log(props.operacion)

                if (props.usuario) {
                    setModulos({
                        accaprosolicompra: props.usuario.accaprosolicompra === null ? '0' : props.usuario.accaprosolicompra,
                        acclisgencompraalmacen: props.usuario.acclisgencompraalmacen === null ? '0' : props.usuario.acclisgencompraalmacen,
                        acclissolicompraalmacen: props.usuario.acclissolicompraalmacen === null ? '0' : props.usuario.acclissolicompraalmacen,
                    });
                    setPermisos({
                        accproveedor: props.usuario.accproveedor === null ? '0000' : props.usuario.accproveedor,
                        accunimedi: props.usuario.accunimedi === null ? '0000' : props.usuario.accunimedi,
                        acctipoproducto: props.usuario.acctipoproducto === null ? '0000' : props.usuario.acctipoproducto,
                        accproducto: props.usuario.accproducto === null ? '0000' : props.usuario.accproducto,
                        accrequisicion: props.usuario.accrequisicion === null ? '0000' : props.usuario.accrequisicion,
                        accsolicompra: props.usuario.accsolicompra === null ? '0000' : props.usuario.accsolicompra,
                        accusuariocompra: props.usuario.accusuariocompra === null ? '0000' : props.usuario.accusuariocompra,
                    });
                } else {
                    setModulos({
                        accaprosolicompra: '0',
                        acclisgencompraalmacen: '0',
                        acclissolicompraalmacen: '0',
                    });
                    setPermisos({
                        accproveedor: '0000',
                        accunimedi: '0000',
                        acctipoproducto: '0000',
                        accproducto: '0000',
                        accrequisicion: '0000',
                        accsolicompra:'0000',
                        accusuariocompra: '0000',
                    });
                }


            }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>{operacion === 1 ? 'Agregar Usuario.' : operacion === 2 ? 'Editar Usuario.' : operacion === 3 ? 'Eliminar Usuario.' : 'Consultar Usuario.'}</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body /*style={{ backgroundColor: "#0e5694", color: "#ffffff" }}*/>
                <Mensaje
                    mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === "Exito."
                            ? cerrarModal()
                            : setMensaje({
                                mostrar: false,
                                titulo: "",
                                texto: "",
                                icono: "",
                            });
                    }}
                />
                {/*   <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <MensajeSiNo titulo={titulo2} mensaje={msg2}
                    show={mostrar1}
                    onHideNo={handleCloseNo} /> */}
                <CatalogoOrganizacion titulo={titulo} mensaje={msg}
                    show={mostrar2}
                    onHideCancelaCatOrg={handleCloseCatalogo}
                    onHideAceptaCatOrg={handleAceptaCatalogo} />
                <CatalogoPersona titulo={titulo} mensaje={msg}
                    show={mostrar3}
                    onHideCancelaCatPer={handleCloseCatalogoPer}
                    onHideAceptaCatPer={handleAceptaCatalogoPer} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div>

                    <ul className="nav" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <a
                                className=" rounded nav-link active bg-blue-100 text-light"
                                id="datosTributarios2"
                                data-bs-toggle="tab"
                                data-bs-target="#tributarios2"
                                type="button"
                                role="tab"
                                aria-controls="tributarios2"
                                aria-selected="true"
                            >
                                Usuario
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className=" rounded nav-link bg-blue-200 text-light"

                                id="deuda-tab2"
                                data-bs-toggle="tab"
                                data-bs-target="#deuda2"
                                type="button"
                                role="tab"
                                aria-controls="deuda2"
                                aria-selected="false"
                            >
                                Permisos de Aplicaciones
                            </a>
                        </li>


                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div
                            className="tab-pane fade show active"
                            id="tributarios2"
                            role="tabpanel"
                            aria-labelledby="datosTributarios2"
                        >
                            {/* DATOS USUARIO */}

                            <div className="col-md-12 row mx-auto border-azul rounded px-0 py-2" >
                                <div class="input-group input-group-sm col-md-3 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Código:</span>
                                    <input type="text" disabled={true} ref={txtIdUsuario} className="form-control form-control-sm" defaultValue={props.usuario ? props.usuario.idusuario : ''} id="inputCodigo" onKeyUp={handleInputChange} />
                                </div>
                                <div className='col-md-3'></div>
                                <div class="input-group input-group-sm col-md-6 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Usuario:</span>
                                    <input type="text" autocomplete="off" disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} ref={txtLogin} className="form-control form-control-sm" defaultValue={props.usuario ? props.usuario.login : ''} id="inputLogin" onKeyUp={handleInputChange} />
                                </div>
                                <div class="input-group input-group-sm col-md-6 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Ingrese Contraseña:</span>
                                    <input type={mostrarClave ? 'text' : 'password'} disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} ref={txtPassword} className="form-control form-control-sm" id="inputPassword" onKeyUp={handleInputChange} />
                                    <button style={{ textAlign: "center", color: "white" }} disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} onClick={mostrarPassword} className="btn btn-sm btn-info"><i disabled={deshabilitado} className="fa fa-eye-slash"></i> </button>

                                </div>
                                <div class="input-group input-group-sm col-md-6 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Confirmar Contraseña:</span>
                                    <input type={mostrarClave1 ? 'text' : 'password'} disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} ref={txtConfirmPassword} className="form-control form-control-sm" id="inputConfirmPassword" onKeyUp={handleInputChange} />
                                    <button style={{ textAlign: "center", color: "white" }} disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} onClick={mostrarPassword1} className="btn btn-sm btn-info"><i disabled={deshabilitado} className="fa fa-eye-slash"></i> </button>

                                </div>


                            </div>
                            <fieldset className=' row col-md-12 border-azul rounded mx-auto d-flex justify-content-between'>
                                <legend className="float-none w-auto " >Organización</legend>
                                <div class="input-group input-group-sm col-md-12 px-0 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Código:</span>
                                    <input type="text" disabled={operacion === 1 || operacion === 2 ? false : true} ref={txtIdOrg} className="form-control col-md-1 form-control-sm" id="inputIdOrg" defaultValue={props.usuario ? props.usuario.idorganizacion : ''} onKeyUp={validarOrg} onBlur={validarOrg} />
                                    <button style={{ textAlign: "center", color: "white" }} disabled={operacion === 1 || operacion === 2 ? false : true} onClick={catalogoOrg} className="btn btn-sm btn-info"><i className="fas fa-search"></i> </button>
                                    <input type="text" disabled={true} ref={txtNomOrg} className="form-control form-control-sm" defaultValue={props.usuario ? props.usuario.razonsocial : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />

                                </div>

                            </fieldset>

                            <fieldset className=' row col-md-12 border-azul rounded mx-auto d-flex justify-content-between'>
                                <legend className="float-none w-auto " >Datos Personales</legend>

                                <div class="input-group input-group-sm col-md-5 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Cedula:</span>
                                    <select name="" disabled={!habilitadoNU} ref={cmbNacionalidad} defaultValue={props.datospersonales ? props.datospersonales.nacionalidad : ''} className="form-select col-md-3" >
                                        <option key="0" value="V">V</option>
                                        <option key="1" value="E">E</option>
                                    </select>
                                    <input type="text" disabled={operacion === 1 || operacion === 2 ? false : true} ref={txtCedula} className="form-control form-control-sm" id="inputCedula" defaultValue={props.datospersonales ? props.datospersonales.cedula : ''} onKeyUp={validarPersona} onBlur={validarPersona} />
                                    <button style={{ textAlign: "center", color: "white" }} disabled={operacion === 1 || operacion === 2 ? false : true} onClick={catalogoPer} className="btn btn-sm btn-info"><i className="fas fa-search"> </i> </button>

                                </div>
                                <div className='col-md-2'></div>
                                <div class="input-group input-group-sm col-md-5 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Fecha de Nacimiento:</span>
                                    <input type="date" disabled={!habilitadoNU} ref={txtFechaNac} className="form-control form-control-sm" id="inputFechaNac" max={fechaSistema} defaultValue={props.datospersonales ? moment.utc(props.datospersonales.fnacimiento).format('YYYY-MM-DD') : ''} onKeyUp={handleInputChange} />

                                </div>


                                <div class="input-group input-group-sm col-md-6 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Nombres:</span>
                                    <input type="text" disabled={!habilitadoNU} ref={txtNombreUsuario} className="form-control form-control-sm" id="inputNomUsuario" defaultValue={props.datospersonales ? props.datospersonales.nombres.trim() : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />

                                </div>

                                <div class="input-group input-group-sm col-md-6 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Apellidos:</span>
                                    <input type="text" disabled={!habilitadoNU} ref={txtApellidoUsuario} className="form-control form-control-sm" id="inputApeUsuario" defaultValue={props.datospersonales ? props.datospersonales.apellidos.trim() : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                </div>

                                <div class="input-group input-group-sm col-md-12 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Dirección:</span>
                                    <textarea type="textarea" style={{ height: 70 }} disabled={!habilitadoNU} ref={txtDireccionUsuario} className="form-control form-control-sm" id="inputDireUsuario" defaultValue={props.datospersonales ? props.datospersonales.direccion.trim() : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />

                                </div>

                                <div class="input-group input-group-sm col-md-4 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Correo:</span>
                                    <input type="text" disabled={!habilitadoNU} ref={txtEmailUsuario} className="form-control form-control-sm" id="inputEmailUsuario" defaultValue={props.datospersonales ? props.datospersonales.correoe !== null ? props.datospersonales.correoe.trim() : '' : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />

                                </div>

                                <div class="input-group input-group-sm col-md-4 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Telefono:</span>
                                    <input type="text" disabled={!habilitadoNU} ref={txtTlfUsuario} className="form-control form-control-sm" id="inputTlfUsuario" placeholder="0000-0000000" defaultValue={props.datospersonales ? props.datospersonales.tlf1 !== null ? props.datospersonales.tlf1.trim() : '' : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />

                                </div>

                                <div class="input-group input-group-sm col-md-4 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Celular:</span>
                                    <input type="text" disabled={!habilitadoNU} ref={txtCelUsuario} className="form-control form-control-sm" id="inputCelUsuario" placeholder="0000-0000000" defaultValue={props.datospersonales ? props.datospersonales.tlf2 !== null ? props.datospersonales.tlf2.trim() : '' : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />

                                </div>

                                <div class="input-group input-group-sm col-md-3 mb-1">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Sexo:</span>
                                    <select name="" disabled={!habilitadoNU} ref={cmbSexo} defaultValue={props.datospersonales ? props.datospersonales.sexo : ''} className="form-select form-select-sm" >
                                        <option key="0" value="M">M</option>
                                        <option key="1" value="F">F</option>
                                    </select>
                                </div>

                               


                            </fieldset>




                        </div>

                        <div
                            className="tab-pane fade"
                            id="deuda2"
                            role="tabpanel"
                            aria-labelledby="deuda-tab2"
                        >


                            <ul className="nav" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <a
                                        className=" rounded nav-link active bg-blue-100 text-light"
                                        id="datosTributarios"
                                        data-bs-toggle="tab"
                                        data-bs-target="#tributarios"
                                        type="button"
                                        role="tab"
                                        aria-controls="tributarios"
                                        aria-selected="true"
                                    >
                                        Actualización
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className=" rounded nav-link bg-blue-200 text-light"
                                        disabled={
                                            operacion === 1 || operacion === 3 ? true : deshabilitado
                                        }
                                        id="deuda-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#deuda"
                                        type="button"
                                        role="tab"
                                        aria-controls="deuda"
                                        aria-selected="false"
                                    >
                                        Reportes
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className=" rounded nav-link bg-blue-300 text-light"
                                        disabled={
                                            operacion === 1 || operacion === 3 ? true : deshabilitado
                                        }
                                        id="hist-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#historico"
                                        type="button"
                                        role="tab"
                                        aria-controls="historico"
                                        aria-selected="false"
                                    >
                                        Usuarios
                                    </a>
                                </li>

                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div
                                    className="tab-pane fade show active border-azul rounded"
                                    id="tributarios"
                                    role="tabpanel"
                                    aria-labelledby="datosTributarios"
                                >

                                    <div className="col-md-12 row mx-auto">
                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-5">
                                                Registro de Proveedores

                                            </div>
                                            <div className="col px-0">

                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkRegContriConsul" name="accproveedor" disabled={deshabilitado} checked={permisos.accproveedor.toString().substring(0, 1) === '1'} onChange={handleChangeChek} />Consultar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkRegContriInc" name="accproveedor" disabled={deshabilitado} checked={permisos.accproveedor.toString().substring(1, 2) === '1'} onChange={handleChangeChek} />Incluir
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkRegContriEdit" name="accproveedor" disabled={deshabilitado} checked={permisos.accproveedor.toString().substring(2, 3) === '1'} onChange={handleChangeChek} />Editar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkRegContriElim" name="accproveedor" disabled={deshabilitado} checked={permisos.accproveedor.toString().substring(3, 4) === '1'} onChange={handleChangeChek} />Eliminar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkRegContriTodo" name="accproveedor" disabled={deshabilitado} checked={permisos.accproveedor.toString() === '1111'} onChange={handleChangeChek} />Todas
                                            </div>

                                        </div>

                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-5">
                                                Registro de Unidades de Medidas

                                            </div>
                                            <div className="col px-0">

                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoConsul" name="accunimedi" disabled={deshabilitado} checked={permisos.accunimedi.toString().substring(0, 1) === '1'} onChange={handleChangeChek} />Consultar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoInc" name="accunimedi" disabled={deshabilitado} checked={permisos.accunimedi.toString().substring(1, 2) === '1'} onChange={handleChangeChek} />Incluir
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoEdit" name="accunimedi" disabled={deshabilitado} checked={permisos.accunimedi.toString().substring(2, 3) === '1'} onChange={handleChangeChek} />Editar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoElim" name="accunimedi" disabled={deshabilitado} checked={permisos.accunimedi.toString().substring(3, 4) === '1'} onChange={handleChangeChek} />Eliminar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoTodo" name="accunimedi" disabled={deshabilitado} checked={permisos.accunimedi.toString() === '1111'} onChange={handleChangeChek} />Todas
                                            </div>

                                        </div>

                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-5">
                                                Registro de Tipos de Productos

                                            </div>
                                            <div className="col px-0">

                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoConsul2" name="acctipoproducto" disabled={deshabilitado} checked={permisos.acctipoproducto.toString().substring(0, 1) === '1'} onChange={handleChangeChek} />Consultar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoInc2" name="acctipoproducto" disabled={deshabilitado} checked={permisos.acctipoproducto.toString().substring(1, 2) === '1'} onChange={handleChangeChek} />Incluir
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoEdit2" name="acctipoproducto" disabled={deshabilitado} checked={permisos.acctipoproducto.toString().substring(2, 3) === '1'} onChange={handleChangeChek} />Editar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoElim2" name="acctipoproducto" disabled={deshabilitado} checked={permisos.acctipoproducto.toString().substring(3, 4) === '1'} onChange={handleChangeChek} />Eliminar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoTodo2" name="acctipoproducto" disabled={deshabilitado} checked={permisos.acctipoproducto.toString() === '1111'} onChange={handleChangeChek} />Todas
                                            </div>

                                        </div>

                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-5">
                                                Registro de Productos

                                            </div>
                                            <div className="col px-0">

                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoConsul3" name="accproducto" disabled={deshabilitado} checked={permisos.accproducto.toString().substring(0, 1) === '1'} onChange={handleChangeChek} />Consultar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoInc3" name="accproducto" disabled={deshabilitado} checked={permisos.accproducto.toString().substring(1, 2) === '1'} onChange={handleChangeChek} />Incluir
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoEdit3" name="accproducto" disabled={deshabilitado} checked={permisos.accproducto.toString().substring(2, 3) === '1'} onChange={handleChangeChek} />Editar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoElim3" name="accproducto" disabled={deshabilitado} checked={permisos.accproducto.toString().substring(3, 4) === '1'} onChange={handleChangeChek} />Eliminar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoTodo3" name="accproducto" disabled={deshabilitado} checked={permisos.accproducto.toString() === '1111'} onChange={handleChangeChek} />Todas
                                            </div>

                                        </div>

                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-5">
                                                Requisición

                                            </div>
                                            <div className="col px-0">

                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoConsul4" name="accrequisicion" disabled={deshabilitado} checked={permisos.accrequisicion.toString().substring(0, 1) === '1'} onChange={handleChangeChek} />Consultar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoInc4" name="accrequisicion" disabled={deshabilitado} checked={permisos.accrequisicion.toString().substring(1, 2) === '1'} onChange={handleChangeChek} />Incluir
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoEdit4" name="accrequisicion" disabled={deshabilitado} checked={permisos.accrequisicion.toString().substring(2, 3) === '1'} onChange={handleChangeChek} />Editar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoElim4" name="accrequisicion" disabled={deshabilitado} checked={permisos.accrequisicion.toString().substring(3, 4) === '1'} onChange={handleChangeChek} />Eliminar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoTodo4" name="accrequisicion" disabled={deshabilitado} checked={permisos.accrequisicion.toString() === '1111'} onChange={handleChangeChek} />Todas
                                            </div>

                                        </div>

                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

<div className="col-md-5">
    Solicitud de Compras

</div>
<div className="col px-0">

    <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoConsul5" name="accsolicompra" disabled={deshabilitado} checked={permisos.accsolicompra.toString().substring(0, 1) === '1'} onChange={handleChangeChek} />Consultar
    <a> &nbsp; </a>
    <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoInc5" name="accsolicompra" disabled={deshabilitado} checked={permisos.accsolicompra.toString().substring(1, 2) === '1'} onChange={handleChangeChek} />Incluir
    <a> &nbsp; </a>
    <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoEdit5" name="accsolicompra" disabled={deshabilitado} checked={permisos.accsolicompra.toString().substring(2, 3) === '1'} onChange={handleChangeChek} />Editar
    <a> &nbsp; </a>
    <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoElim5" name="accsolicompra" disabled={deshabilitado} checked={permisos.accsolicompra.toString().substring(3, 4) === '1'} onChange={handleChangeChek} />Eliminar
    <a> &nbsp; </a>
    <input type="checkbox" style={{ marginRight: "3px" }} id="chkActiviEconoTodo5" name="accsolicompra" disabled={deshabilitado} checked={permisos.accsolicompra.toString() === '1111'} onChange={handleChangeChek} />Todas
</div>

</div>


                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-6">
                                                Aprobar Solicitud de Compra

                                            </div>
                                            <div className="col row">

                                                <div className="form-check form-check-inline col">
                                                    <input className="form-check-input" type="radio" name="accaprosolicompra" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accaprosolicompra === '1'} onChange={handleChangeOtro} />
                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                </div>
                                                <div className="form-check form-check-inline col">
                                                    <input className="form-check-input" type="radio" name="accaprosolicompra" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accaprosolicompra === '0'} onChange={handleChangeOtro} />
                                                    <label className="form-check-label" htmlFor="inlineRadio2">No disponible</label>
                                                </div>
                                            </div>

                                        </div>
                                      

                                      
                                      

                                    </div>

                                </div>

                                <div
                                    className="tab-pane fade"
                                    id="deuda"
                                    role="tabpanel"
                                    aria-labelledby="deuda-tab"
                                >

                                    <div className='col-md-12 row mx-auto border-azul rounded'>
                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-6">
                                                Listado Generales

                                            </div>
                                            <div className="col row">

                                                <div className="form-check form-check-inline col">
                                                    <input className="form-check-input" type="radio" name="acclisgencompraalmacen" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.acclisgencompraalmacen === '1'} onChange={handleChangeOtro} />
                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                </div>
                                                <div className="form-check form-check-inline col">
                                                    <input className="form-check-input" type="radio" name="acclisgencompraalmacen" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.acclisgencompraalmacen === '0'} onChange={handleChangeOtro} />
                                                    <label className="form-check-label" htmlFor="inlineRadio2">No Disponible</label>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-6">
                                                Listado de Solicitudes
                                            </div>
                                            <div className="col row">

                                                <div className="form-check form-check-inline col">
                                                    <input className="form-check-input" type="radio" name="acclissolicompraalmacen" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.acclissolicompraalmacen === '1'} onChange={handleChangeOtro} />
                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                </div>
                                                <div className="form-check form-check-inline col">
                                                    <input className="form-check-input" type="radio" name="acclissolicompraalmacen" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.acclissolicompraalmacen === '0'} onChange={handleChangeOtro} />
                                                    <label className="form-check-label" htmlFor="inlineRadio2">No disponible</label>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div
                                    className="tab-pane fade"
                                    id="historico"
                                    role="tabpanel"
                                    aria-labelledby="hist-tab"
                                >
                                    <div className="col-md-12 row mx-auto">
                                        <div className="col-md-12 row mx-auto rounded border my-2 py-2">

                                            <div className="col-md-5">
                                                Módulo de Usuarios

                                            </div>
                                            <div className="col px-0">

                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeConsul" name="accusuariocompra" disabled={deshabilitado} checked={permisos.accusuariocompra.toString().substring(0, 1) === '1'} onChange={handleChangeChek} />Consultar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeInc" name="accusuariocompra" disabled={deshabilitado} checked={permisos.accusuariocompra.toString().substring(1, 2) === '1'} onChange={handleChangeChek} />Incluir
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeEdit" name="accusuariocompra" disabled={deshabilitado} checked={permisos.accusuariocompra.toString().substring(2, 3) === '1'} onChange={handleChangeChek} />Editar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeElim" name="accusuariocompra" disabled={deshabilitado} checked={permisos.accusuariocompra.toString().substring(3, 4) === '1'} onChange={handleChangeChek} />Eliminar
                                                <a> &nbsp; </a>
                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeTodo" name="accusuariocompra" disabled={deshabilitado} checked={permisos.accusuariocompra.toString() === '1111'} onChange={handleChangeChek} />Todas
                                            </div>

                                        </div>
                                      

                                    </div>

                                </div>
                            </div>

                        </div>


                    </div>



                </div>
            </Modal.Body>
            <Modal.Footer /*style={{ backgroundColor: "rgb(106, 115, 123)" }}*/>
                <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-sm btn-success rounded-pill"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}